import axios from 'axios';
import { FormErrors } from '../utils/FormErrors';
import { ftpStates } from '../mixins/functions';

const exportFormDefaults = {
  alias: null,
  translate: {},
  round: null,
  index: null,
  value: null,
  name: null,
  from: null,
  to: null,
  not_exported: 0,
  already_exported: 0,
  set_export_flag: 0,
  file_type: null,
  scheme: null,
  timeType: null,
  timeRange: null,
  timeHour: null,
  timeMinute: null,
  emails: [{ email: '' }],
  energy_type: [],
  type: null,
  host: null,
  port: 21,
  username: null,
  password: null,
  path: null,
  ssl: 0,
  ssh: 0,
  ftpType: ftpStates.data().ftpType,
  ftp: false,
  can_set_export_indicator: 0,
  brand: null,
  product: [],
  since_beginning: 0,
  ignore_export_ready_flag: 0,
  include_trashed: 0,
  customer_type: null,
  private_key: null,
  customFormatting: 0,
  decimalSeparator: '.',
  encoding: 'utf-8',
  delimiter: 'comma',
  salesChannels: [],
  orderTypes: [],
  onlyUpdated: 0,
  filename: 'Export vom {{createdAt|d.m.Y H-i-s}}',
  hasPassword: false,
  hasPrivateKey: false,
  privateKeyName: null,
  removePrivateKey: false,
  failureRecipients: [{ email: '' }],
};

// A fresh copy each time, so arrays such as `emails` are never shared with the defaults.
const createFormDefaults = () => JSON.parse(JSON.stringify(exportFormDefaults));

// SimpleList edits object rows; the request and toFormData() carry plain address strings.
const toEmailRows = (emails) => (Array.isArray(emails) && emails.length
  ? emails.map((email) => ({ email }))
  : [{ email: '' }]);

const noEdit = () => ({ uuid: null, url: null });

export default {
  namespaced: true,
  state: {
    alias: null,
    api: {},
    fields: [],
    field: {},
    newField: false,
    errors: new FormErrors(),
    createPopup: false,
    selectedTab: 'export',
    schemes: [],
    form: createFormDefaults(),
    // The automatic export being edited; uuid null = create mode.
    edit: noEdit(),
  },
  mutations: {
    SET_TAB(state, tab) {
      state.selectedTab = tab;
    },
    SET_ITEM(state, [key, value, index]) {
      if (Array.isArray(state[key])) {
        const result = [...state[key]];
        result[index] = value;
        if (index !== null) {
          state[key] = result;
        } else {
          state[key] = value;
        }
      } else {
        state[key] = value;
      }
      state.errors.clear(key);
    },
    UPDATE_FORM(state, form) {
      state.form = { ...form };
    },
    SET_EDIT(state, edit) {
      state.edit = edit ? { uuid: edit.uuid, url: edit.url } : noEdit();
    },
    SET_CREATE_POPUP(state, create) {
      state.createPopup = create;
    },
    SET_SCHEMES(state, schemes) {
      state.schemes = schemes || [];
    },
  },
  actions: {
    SET_TAB({ commit }, tab) {
      commit('SET_TAB', tab);
    },
    SET_CREATE_POPUP({ commit }, create) {
      commit('SET_CREATE_POPUP', create);
    },
    SET_SCHEMES({ commit }, schemes) {
      commit('SET_SCHEMES', schemes);
    },
    VALIDATE_SCHEMES({ dispatch, state }) {
      if (state.alias) {
        dispatch('CREATE_SCHEMES');
      } else {
        // eslint-disable-next-line no-underscore-dangle
        this._vm.$notify({
          group: 'foo',
          type: 'error',
          title: 'Wichtige Mitteilung',
          text: 'Nicht alle Pflichtfelder ausgefüllt.',
        });
      }
    },
    async CREATE_SCHEMES({ state }) {
      try {
        await axios.post(state.api.store, {
          alias: state.alias,
        });
        window.location.href = state.api.store;
      } catch (err) {
        Object.values(err.response.data.errors || {}).forEach((error) => {
          window.GlobalEvents.fire('alert', [
            {
              message: error[0],
              type: 'error',
            },
          ]);
        });
      }
    },
    async CLEAR_DATA({ commit, state }) {
      commit('UPDATE_FORM', createFormDefaults());
      commit('SET_EDIT', null);
      state.errors.clear();
    },
    /**
     * Opens an automatic export for editing with the data its list row carries
     * (`defaults` = AutomaticExport::toFormData(), `action` = update URL).
     */
    START_EDIT({ commit, state }, { defaults, action }) {
      const values = JSON.parse(JSON.stringify(defaults));
      commit('UPDATE_FORM', {
        ...createFormDefaults(),
        ...values,
        emails: toEmailRows(values.emails),
        failureRecipients: toEmailRows(values.failureRecipients),
      });
      commit('SET_EDIT', { uuid: defaults.uuid, url: action });
      state.errors.clear();
    },
  },
  getters: {
    isEditing(state) {
      return !!(state.edit && state.edit.uuid);
    },
    ftpFilled(state) {
      return !!(state.form.type === 'ftp' && state.form.host && state.form.port && state.form.path);
    },
  },
};
